exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cancel_dialog{min-width: 600px;}\n.head_line b{padding: 11px 10px; margin-bottom: 0px; display: block; background: #e9ecef;}\n.cancel_attendee p{padding: 11px 10px; margin-bottom: 0px; display: block;}\n.cancel_attendee .row .col-md-2, .cancel_attendee .row .col-md-3,.cancel_attendee .row .col-md-4, .cancel_attendee .row .col-md-5{padding: 0px;}\n.cancel_attendee .row{border-bottom: 1px solid #e9ecef;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/cancel-attendee/cancel-attendee.component.css
// module id = ../../../../../src/app/admin/cancel-attendee/cancel-attendee.component.css
// module chunks = 39